import { Stack, useToast } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useNavigateNext from '../../../hooks/useNavigateNext'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import useReportingForMonth from '../../../hooks/useReportingForMonth'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'

// Import local components, hooks, and types
import StoolForm from './components/StoolForm'
import UrineForm from './components/UrineForm'
import useStoolState from './hooks/useStoolState'

export default function StoolPage() {
  const isValidated = useReportMonthGuard()
  const { state, setState } = useStoolState()
  const navNext = useNavigateNext()
  const toast = useToast()
  const purpleBubbleContent = usePurpleBubblesText('Step-4')
  const { year } = useReportingForMonth()

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  const isStoolComplete = () => {
    const { stool } = state
    return (
      stool.type &&
      stool.color &&
      stool.odor &&
      stool.volume &&
      stool.float !== undefined &&
      stool.daily !== undefined &&
      stool.times &&
      stool.giSymptoms &&
      stool.giSymptoms.length > 0
    )
  }

  const isUrineComplete = () => {
    const { urine } = state
    return urine.timesDaily && urine.color && urine.odor
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (isStoolComplete() && isUrineComplete()) {
      navNext()
    } else {
      toast({
        status: 'warning',
        title: 'Please complete all required fields',
      })
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={6}>
        <MonthlyReportHeader title='Tell us about your stool and urine.' />
        {purpleBubbleContent?.text && (
          <PurpleBubbleContent text={purpleBubbleContent.text} />
        )}
        <StoolForm state={state} setState={setState} year={year} />
        <UrineForm state={state} setState={setState} />
        <MonthlyReportNavButtons />
      </Stack>
    </form>
  )
}
